import { Injectable } from "@angular/core";
import { BehaviorSubject, fromEvent, merge, of, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";
import { SocketsConnectionService } from "../websockets/connection.service";

@Injectable({
  providedIn: "root",
})
export class ConnectionService {
  status: BehaviorSubject<string> = new BehaviorSubject("ONLINE");
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;
  constructor(private socketsConnectionService: SocketsConnectionService) {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, "online"),
      fromEvent(window, "offline")
    )
      .pipe(map(() => navigator.onLine))
      .subscribe((status: boolean) => {
        console.log("status", status);
        this.networkStatus = status;
        if (this.networkStatus) {
          this.status.next("ONLINE");
          this.socketsConnectionService.subscribeToSockets();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
          });

          // Toast.fire({
          //   type: "success",
          //   title: "You are now online !",
          //   timer: 2000,
          // });
        } else {
          this.status.next("OFFLINE");
          this.socketsConnectionService.disconnect();
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: true,
          });

          Toast.fire({
            type: "warning",
            title:
              "Please check your Internet connection before proceeding further !",
          });
        }
      });
    console.log("networkStatus", this.networkStatus);
  }
}
